<script>
import {mapGetters} from 'vuex'
import Faq from '../components/faq/Faq.vue'
export default {
  name: 'FaqView',
  components: {
    Faq
  },
  title() {
    return 'FAQ'
  },
  computed: {
    ...mapGetters(['isAuthenticated']),
    PACKAGE_VERSION() {
      return process.env.PACKAGE_VERSION
    }
  }
}
</script>
<template>
  <v-container fluid>
    <v-card class="pa-5">
      <v-row justify="center">
        <v-col cols="12">
          <v-card-subtitle class="text-center primary--text display-1 font-weight-bold">
              <h2>{{ $t('page.faq.view.header') }}</h2>
          </v-card-subtitle>
          <v-divider class="my-2"></v-divider>
          <v-card-text>
            <Faq headers/>
          </v-card-text>
        </v-col>
      </v-row>
    </v-card>
  </v-container>
</template>
